module.exports = __webpack_public_path__ + "img/participantes.f2d52213.svg";